import CustomNotify from "components/common/atoms/CustomNotify";
import type { MediaPayload } from "../annotations/WhatsAppAnnotations";
import { t } from "components/CentralDataMangement/translation/Translation";

export const validateFiles = (
  selectedFiles: FileList,
  existingFiles: MediaPayload[]
): File[] => {
  const totalAllowedFiles = 5;
  const maxTotalSizeBytes = 10 * 1024 * 1024; // 10 MB
  const maxFileSizeBytes = 10 * 1024 * 1024; // 10 MB

  const alreadyUploadedCount = existingFiles.length;
  const remainingFileSlots = totalAllowedFiles - alreadyUploadedCount;

  if (remainingFileSlots <= 0) {
    CustomNotify({
      type: "warning",
      message: t("You have already uploaded the maximum of 5 images"),
    });
    return [];
  }

  const currentTotalSize = existingFiles.reduce(
    (acc, file) => acc + (file.mediaFile?.size || 0),
    0
  );

  const filesArray = Array.from(selectedFiles);
  const validFiles: File[] = [];
  let cumulativeSize = currentTotalSize;

  for (const file of filesArray) {
    if (validFiles.length >= remainingFileSlots) {break;}

    if (file.size > maxFileSizeBytes) {
      CustomNotify({
        type: "error",
        message: t(
          `File "${file.name}" exceeds the 10 MB size limit and was not uploaded.`
        ),
      });
      return [];
    }

    if (cumulativeSize + file.size > maxTotalSizeBytes) {
      CustomNotify({
        type: "error",
        message: t(
          "Upload limit reached. Please ensure files are under 10 MB"
        ),
      });
      return [];
    }

    cumulativeSize += file.size;
    validFiles.push(file);
  }

  return validFiles;
};
